import { API_THINGS, API_THINGS_BUCKETS, API_THINGS_CONFIGS, API_THINGS_LABELS, API_THINGS_SHAPES, AUTH_BEARER } from "../constants";
import { Thing, ThingBucketType, ThingShape } from "../types/ThingType";
import { axiosDelete, axiosGet, axiosPatch, axiosPost, axiosPut, getAuthorization } from "../utils/axios";


const ThingApi = {
  getThingList: async (paginationParams: any) => {

    const headers = {
      ...getAuthorization(AUTH_BEARER),
    };

    return await axiosGet(API_THINGS, { ...paginationParams }, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error getThingList:", error);
        return error.response.data;
      });
  },

  getThingById: async (id: string) => {

    const headers = {
      ...getAuthorization(AUTH_BEARER),
    };

    return await axiosGet(`${API_THINGS}/${id}`, {}, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error getThingById:", error);
        return error.response.data;
      });
  },

  createThing: async (thingObj: Thing) => {

    const headers = {
      ...getAuthorization(AUTH_BEARER),
    };

    return await axiosPost(API_THINGS, thingObj, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error createThing:", error);
        return error.response.data;
      });
  },

  updateThing: async (id: string, thingObj: Thing) => {

    const headers = {
      ...getAuthorization(AUTH_BEARER),
    };

    return await axiosPatch(`${API_THINGS}/${id}`, thingObj, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error updateThing:", error);
        return error.response.data;
      });
  },

  deleteThing: async (id: string) => {

    const headers = {
      ...getAuthorization(AUTH_BEARER),
    };

    return await axiosDelete(`${API_THINGS}/${id}`, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error deleteThing:", error);
        return error.response.data;
      });
  },

  listConfigs: async (id: string) => {

    const headers = {
      ...getAuthorization(AUTH_BEARER),
    };

    return await axiosGet(`${API_THINGS}/${id}${API_THINGS_CONFIGS}`, {}, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error listConfigs:", error);
        return error.response.data;
      });
  },

  getConfigByName: async (thingId: string, name: string) => {

    const headers = {
      ...getAuthorization(AUTH_BEARER),
    };

    return await axiosGet(`${API_THINGS}/${thingId}${API_THINGS_CONFIGS}/${name}`, {}, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error getConfigByName:", error);
        return error.response.data;
      });
  },

  createUpdateConfig: async (thingId: string, name: string, configObj: any) => {

    const headers = {
      ...getAuthorization(AUTH_BEARER),
    };

    return await axiosPut(`${API_THINGS}/${thingId}${API_THINGS_CONFIGS}/${name}`, configObj, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error createUpdateConfig:", error);
        return error.response.data;
      });
  },

  deleteConfig: async (id: string, name: string) => {

    const headers = {
      ...getAuthorization(AUTH_BEARER),
    };

    return await axiosDelete(`${API_THINGS}/${id}${API_THINGS_CONFIGS}/${name}`, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error deleteConfig:", error);
        return error.response.data;
      });
  },

  getConfigReportRecords: async (thingId: string, name: string, begin: string, end: string, paginationParams: any) => {

    const headers = {
      ...getAuthorization(AUTH_BEARER),
    };

    return await axiosGet(`${API_THINGS}/${thingId}${API_THINGS_BUCKETS}/${name}/telemetry`, { begin, end, ...paginationParams }, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error getConfigReportRecords:", error);
        return error.response.data;
      });
  },

  putLabel: async (id: string, key: string, value: string) => {

    const headers = {
      ...getAuthorization(AUTH_BEARER),
    };

    return await axiosPut(`${API_THINGS}/${id}${API_THINGS_LABELS}/${key}`, { 'value': value }, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error putLabel:", error);
        return error.response.data;
      });
  },

  deleteLabel: async (id: string, key: string) => {

    const headers = {
      ...getAuthorization(AUTH_BEARER),
    };

    return await axiosDelete(`${API_THINGS}/${id}${API_THINGS_LABELS}/${key}`, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error deleteLabel:", error);
        return error.response.data;
      });
  },

  createDataBucket: async (id: string, objs: ThingBucketType) => {

    const headers = {
      ...getAuthorization(AUTH_BEARER),
    };

    return await axiosPost(`${API_THINGS}/${id}${API_THINGS_BUCKETS}`, objs, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error createDataBucket:", error);
        return error.response.data;
      });
  },

  listDataBuckets: async (id: string) => {

    const headers = {
      ...getAuthorization(AUTH_BEARER),
    };

    return await axiosGet(`${API_THINGS}/${id}${API_THINGS_BUCKETS}`, {}, headers)
      .then((res) => res.data.data)
      .catch((error) => {
        console.error("Error listDataBuckets:", error);
        return error.response.data;
      });
  },

  listDataShapes: async (id: string, dataBucketName: string) => {

    const headers = {
      ...getAuthorization(AUTH_BEARER),
    };

    return await axiosGet(`${API_THINGS}/${id}${API_THINGS_BUCKETS}/${dataBucketName}${API_THINGS_SHAPES}`, {}, headers)
      .then((res) => res.data.data)
      .catch((error) => {
        console.error("Error listDataShapes:", error);
        return error.response.data;
      });
  },

  createDataShape: async (id: string, dataBucketName: string, obj: ThingShape) => {

    const headers = {
      ...getAuthorization(AUTH_BEARER),
    };

    return await axiosPost(`${API_THINGS}/${id}${API_THINGS_BUCKETS}/${dataBucketName}${API_THINGS_SHAPES}`, obj, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error createDataShape:", error);
        return error.response.data;
      });
  },

  updateDataShape: async (id: string, dataBucketName: string, dataShapeName: string, alias: string, unit: string) => {

    const headers = {
      ...getAuthorization(AUTH_BEARER),
    };

    return await axiosPatch(`${API_THINGS}/${id}${API_THINGS_BUCKETS}/${dataBucketName}${API_THINGS_SHAPES}/${dataShapeName}`,
      { 'alias': alias, 'unit': unit }, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error updateDataShape:", error);
        return error.response.data;
      });
  },

  deleteBucket: async (id: string, name: string) => {

    const headers = {
      ...getAuthorization(AUTH_BEARER),
    };

    return await axiosDelete(`${API_THINGS}/${id}${API_THINGS_BUCKETS}/${name}`, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error deleteBucket:", error);
        return error.response.data;
      });
  },

  deleteShape: async (id: string, name: string, shapeName: string) => {

    const headers = {
      ...getAuthorization(AUTH_BEARER),
    };

    return await axiosDelete(`${API_THINGS}/${id}${API_THINGS_BUCKETS}/${name}${API_THINGS_SHAPES}/${shapeName}`, headers)
      .then((res) => res.data)
      .catch((error) => {
        console.error("Error deleteShape:", error);
        return error.response.data;
      });
  },
};

export default ThingApi;
